const diff = (obj1, obj2) => {
  const toMutate = {}
  if (!obj1 || !obj2) {
    return obj2 ? obj2 : toMutate
  }
  Array.from(new Set([...Object.keys(obj1), ...Object.keys(obj2)])).map(key => {
    if (obj1[key] !== obj2[key]) {
      toMutate[key] = obj2[key]
    }
    return null
  })
  return toMutate
}

export default diff



// WEBPACK FOOTER //
// ./src/utility/diff.js